import {Component, ElementRef, OnInit} from '@angular/core';
import {WidgetBaseGridComponent} from '../widget-base/widget-base-grid.component';
import {MessageService} from '../../messages/message.service';
import {PublisherService} from '../../pusblisher/publisher.service';
import {ConfigurationService} from '../../Configuration/configuration-service';
import {WidgetService} from '../widget.service';
import {HttpClient} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {TranslationService} from '../../TranslationMarkers/translation.service';

@Component({
  selector: 'dora-grid-data-notes',
  templateUrl: './dora-grid-notes.component.html',
  styleUrls: ['./dora-grid-notes.component.scss']
})
export class DoraGridNotesComponent extends WidgetBaseGridComponent {

  constructor(elementRef: ElementRef<any>,
              messageService: MessageService,
              configurationService: ConfigurationService,
              publisher: PublisherService,
              widgetService: WidgetService,
              http: HttpClient,
              translationService: TranslationService) {
    super(elementRef, messageService, configurationService, publisher, widgetService, http, translationService);

    this.flSelectFirstRow = false;
  }
}
